__turbopack_context__.v({
  "body": "FeatureGrid-module__FlxYIG__body",
  "buttons": "FeatureGrid-module__FlxYIG__buttons",
  "cell": "FeatureGrid-module__FlxYIG__cell",
  "content": "FeatureGrid-module__FlxYIG__content",
  "core": "FeatureGrid-module__FlxYIG__core",
  "corebase": "FeatureGrid-module__FlxYIG__corebase",
  "coreimage": "FeatureGrid-module__FlxYIG__coreimage",
  "coremeta": "FeatureGrid-module__FlxYIG__coremeta",
  "corenoise": "FeatureGrid-module__FlxYIG__corenoise",
  "coreone": "FeatureGrid-module__FlxYIG__coreone",
  "corestroke": "FeatureGrid-module__FlxYIG__corestroke",
  "coretwo": "FeatureGrid-module__FlxYIG__coretwo",
  "grid": "FeatureGrid-module__FlxYIG__grid",
  "icon": "FeatureGrid-module__FlxYIG__icon",
  "large": "FeatureGrid-module__FlxYIG__large",
  "largeTitle": "FeatureGrid-module__FlxYIG__largeTitle",
  "rotate": "FeatureGrid-module__FlxYIG__rotate",
  "title": "FeatureGrid-module__FlxYIG__title",
  "twoanimation": "FeatureGrid-module__FlxYIG__twoanimation",
  "wrapper": "FeatureGrid-module__FlxYIG__wrapper",
});
